import { render, staticRenderFns } from "./myResourceStudentList.vue?vue&type=template&id=213f4498&scoped=true"
import script from "./myResourceStudentList.vue?vue&type=script&lang=js"
export * from "./myResourceStudentList.vue?vue&type=script&lang=js"
import style0 from "./myResourceStudentList.vue?vue&type=style&index=0&id=213f4498&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f4498",
  null
  
)

export default component.exports